export function signInRequest(subdominio, usuario, senha) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { subdominio, usuario, senha },
  };
}

export function signInSuccess(token, user, usuarioacesso, modules, lang) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user, usuarioacesso, modules, lang },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  };
}
